const BanTimesSCP = [
    { text: "Kick", time: "0" },
    { text: "1 min", time: "1" },
    { text: "5 min", time: "5" },
    { text: "15 min", time: "15" },
    { text: "30 min", time: "30" },
    { text: "1 h", time: "60" },
    { text: "3 h", time: "180" },
    { text: "5 h", time: "300" },
    { text: "8 h", time: "480" },
    { text: "12 h", time: "720" },
    { text: "1 d", time: "1440" },
    { text: "3 d", time: "7200" },
    { text: "7 d", time: "10080" },
    { text: "14 d", time: "20160" },
    { text: "30 d", time: "43200" },
    { text: "100 d", time: "144000" },
    { text: "1 y", time: "525600" },
    { text: "50 y", time: "26280000" },
]
export default BanTimesSCP;